import { ref } from 'vue';
import DeviceIphone from '../../components/device/component-lib.esm2.js';
import { ThemeProvider } from '../../styles/theme/component-lib.esm3.js';
import ScaledDevice from '../../components/device/component-lib.esm.js';
import PreviewProfile from './component-lib.esm3.js';
import Skeleton from '../../components/skeleton/component-lib.esm.js';

//
var script = {
  name: 'Preview',
  components: {
    ThemeProvider,
    ScaledDevice,
    PreviewProfile,
    DeviceIphone,
    Skeleton
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    links: {
      type: Array,
      default: () => []
    },
    socialAccounts: {
      type: Array,
      required: true
    },
    defaultProfileImage: {
      type: String,
      required: true
    },
    theme: {
      type: [String, Object],
      default: null
    },
    loading: Boolean,
    isFreePlan: Boolean
  },
  setup() {
    const preview = ref(null);
    function scrollToLink(id) {
      preview.value.scrollToLink(id);
    }
    return {
      scrollToLink,
      preview
    };
  }
};
export { script as default };